import React, { useEffect } from 'react';
import NewLanding from '../components/newLanding/NewLanding';

/**
 * Marketing landing — jeden komponent (landing od kolegi wpięty w React).
 * Panel / billing zostaje w AppPlatform na ścieżkach / app.*.
 */
const MainSite: React.FC = () => {
  useEffect(() => {
    document.documentElement.classList.add('landing-page-active');
    document.body.classList.add('landing-page-active');
    return () => {
      document.documentElement.classList.remove('landing-page-active');
      document.body.classList.remove('landing-page-active');
    };
  }, []);

  return <NewLanding />;
};

export default MainSite;
